import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { InputWrapperComponent } from '../input-wrapper/input-wrapper.component';

@Component({
  selector: 'psc-file-input',
  templateUrl: './file-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileInputComponent extends InputWrapperComponent<File[]>{

  @Input() placeholder: string;
  @Input() fileInfoText: string;
  @Input() multiple: boolean = false;

  mapToType(fileType: string) {
    return fileType.split(', ').map(t => '.' + t);
  }
}
